export const Produtos = [
    
    {
        id: 1,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/2WF8mTS/68daab7ec224f8df147cf39c29f213c8.jpg",
        title:"Biografia Inspire Desodorante Colônia Feminino",
        qtdInStock: 1,
        price: 115.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"
    },
    {
        id: 2,
        category: "Perfumaria",
        imageUrl:"https://static.natura.com/cdn/ff/bCg8tW-ReFrrZgj7NWNE6h5St_dUjDtQyWfSXamfYSQ/1640585149/public/products/18529_3.jpg",
        title:"Kaiak Vital Desodorante Colônia Masculino",
        qtdInStock: 1,
        price:120.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 3,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/8dYX2hs/61p-G0-Rj-Vf-RS-AC-SX425.jpg",
        title:"Presente Natura Ekos Madeira Em Flor",
        qtdInStock: 1,
        price:150.00,
        description: "Os itens podem ser vendidos saparados, entre em contato para mais detalhes ;)"
    },
    {
        id: 4,
        category: "Perfumaria",
        imageUrl:"https://static.natura.com/cdn/ff/Htkc4SDPBwt7WOAIcLgcElBji_xVQMjm7lxY85Dofns/1640583754/public/products/107567_3.jpg",
        title:"Presente Natura Luna Absoluta",
        qtdInStock: 1,
        price:189.90,
        description: "Os itens podem ser vendidos saparados, entre em contato para mais detalhes ;)"

    },
    {
        id: 5,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/SnvpqRS/71cd-Ylth-PSL-AC-SX425.jpg",
        title:"Presente Natura Kaiak Feminino",
        qtdInStock: 1,
        price:183.70,
        description: "Os itens podem ser vendidos saparados, entre em contato para mais detalhes ;)"

    },

   /* {
        id: 6,
        category: "Banho/Corpo",
        imageUrl:"https://static.natura.com/cdn/ff/fOF8AIg_0T_uLarKscmjKeog3tk0WF6DZLhlTZt8T64/1640575458/public/products/2832_3.jpg",
        title:"Sabonete em Barra Puro Vegetal Tododia Noz Pecã e Cacau",
        qtdInStock: 1,
        price:22.00,
    },
    {
        id: 7,
        category: "Banho/Corpo",
        imageUrl:"https://static.natura.com/cdn/ff/lhjdOHRK048d0aiKvyW-0Mb5dSvDL5DaK7D3wfEkF9A/1640576074/public/products/72147_3.jpg",
        title:"Sabonete em Barra Puro Vegetal Tododia Alecrim e Sálvia",
        qtdInStock: 1,
        price:22.20,
    },
    {
        id: 8,
        category: "Banho/Corpo",
        imageUrl:"https://static.natura.com/cdn/ff/E_CUevvkbEm3m5xItkznNyO5P2aBDlgGPSBfaGP96PU/1640584600/public/products/115953_1_8.jpg",
        title:" Creme Desodorante para o Corpo Amora Vermelha e Jabuticaba",
        qtdInStock: 1,
        price:55.90,
    },*/
    {
        id: 8,
        category: "Perfumaria",
        imageUrl:"https://static.natura.com/cdn/ff/VLMdq1fXnwF1sidFX3TyPXsGE0r9yRKmTmcPMqBnGBU/1640600384/public/styles/medium/public/products/86728_1_21.jpg?itok=0INuOSSF",
        title:"Paz e Humor Desodorante Colônia",
        qtdInStock: 1,
        price:105.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 9,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/bNQr9k7/48832234-1.jpg",
        title:"Refil Desodorante Corporal Meu Primeiro Humor Feminino",
        qtdInStock: 1,
        price:28.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 10,
        category: "Perfumaria",
        imageUrl:"https://static.natura.com/cdn/ff/S9IklpQhpmJ1BCdLnH6vJ4pQaiS6NgQ_ws-AgspdFU4/1641233756/public/products/56764_1_2.jpg",
        title:"Refil Desodorante Corporal Kaiak Aventura Masculino ",
        qtdInStock: 1,
        price:36.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    // {
    //     id: 11,
    //     category: "Perfumaria",
    //     imageUrl:"https://static.natura.com/cdn/ff/o7QgaeT31eHNSM1NzhbMRrX9ctcKbxWj-9DErvBLlJ4/1641234299/public/products/56747_3.jpg",
    //     title:"Refil Desodorante Corporal Kaiak Urbe",
    //     qtdInStock: 1,
    //     price:36.00,
    //     description: "À vista, o preço pode ser negociável, entre em contato ;)"

    // },
    {
        id: 12,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/gr8kM6x/kaiakF.jpg",
        title:"Refil Desodorante Corporal Kaiak Aventura Feminino ",
        qtdInStock: 1,
        price:36.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 13,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/G0D3yN9/56417-complementar.jpg",
        title:"Luna Absoluta Desodorante Colônia - 75 ml",
        qtdInStock: 1,
        price:130.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 14,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/qJvBymy/73565-beneficios.jpg",
        title:"Ekos Frescor Açaí Desodorante Colônia Feminino - 150 ml",
        qtdInStock: 1,
        price:85.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 15,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/fNJfrTw/86723-1-22.jpg",
        title:"Colônia Meu Primeiro Humor - 75 ml",
        qtdInStock: 1,
        price:105.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 16,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/sW2K1yk/18396-dicas-de-uso.jpg",
        title:"Ekos Frescor Ishpink Desodorante Colônia Feminino - 150 ml",
        qtdInStock: 1,
        price:85.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"
    },
    {
        id: 17,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/pjBYTnv/c61b251f55.jpg",
        title:"Colônia Todo dia Body Splash Framboesa e Pimenta Vermelha - 200 ml ",
        qtdInStock: 1,
        price:55.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 18,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/C1PswBB/2031035775-1-SZ.jpg",
        title:"Desodorante Colônia Kriska Delírio Feminino - 100ml",
        qtdInStock: 1,
        price:100.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 19,
        category: "Perfumaria",
        imageUrl:"https://cf.shopee.com.br/file/8442e1cc7de30635808aa00ac76f2543",
        title:"Desodorante Colônia Essencial Exclusivo Floral - 100ml ",
        qtdInStock: 1,
        price:170.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 20,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/9Hks6wD/2360a4872ef0a60260c1c93f0a07f98a.jpg",
        title:" Desodorante Colônia Frescor Feminino Ekos Moça - 75 ml",
        qtdInStock: 1,
        price:60.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 21,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/WKxdvTQ/73564-beneficios.jpg",
        title:"Ekos Frescor Maracujá Desodorante Colônia - 75 ml",
        qtdInStock: 1,
        price:85.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 22,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/pRm9SVt/87512-5.jpg",
        title:"Sabonete em Barra Puro Vegetal Tododia Amora Vermelha e Jabuticaba - 5 un. de 90g cada",
        qtdInStock: 2,
        price:22.00,
    },
    {
        id: 23,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/z4J7bwD/2829-6.jpg",
        title:" Sabonete em Barra Puro Vegetal Tododia Macadâmia - 5 un. 90 g cada",
        qtdInStock: 2,
        price:22.00,
    },/*
    {
        id: 24,
        category: "Banho/Corpo",
        imageUrl:"https://static.natura.com/cdn/ff/kt3ucnYLV0z3l9TgAN2xJBtO-dLSsioaGgKWY5zsDeM/1641232902/public/products/91217_6.jpg",
        title:"Desodorante Antitranspirante em Creme Tododia Manga Rosa e Água de Coco - 80 g",
        qtdInStock: 1,
        price:20.00,
    },*/
    {
        id: 25,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/f1XJpxj/1621086222-1-GG.jpg",
        title:"Creme Desodorante Nutritivo Para o Corpo Cereja e Avelã - 400ml",
        qtdInStock: 1,
        price:50.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 26,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/F5V58y2/9594d33f997a1ef1aba086edc16d514c.jpg",
        title:"Creme Desodorante Nutritivo Para o Corpo Framboesa e Pimenta Vermelha - 400ml",
        qtdInStock: 1,
        price:50.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 27,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/9w1VzmJ/2814-0.jpg",
        title:" Creme Desodorante Nutritivo Para o Corpo Tododia Macadâmia - 400ml",
        qtdInStock: 1,
        price:50.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 28,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/pyxv8KY/2826-9.jpg",
        title:"Creme Desodorante Nutritivo Para o Corpo Tododia Flor de Lis - 400ml",
        qtdInStock: 1,
        price:50.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 29,
        category: "Cabelos",
        imageUrl:"https://i.ibb.co/b12MXPY/cond-1-8.jpg",
        title:"Refil Condicionador Suave Mamãe e Bebê - 200ml",
        qtdInStock: 1,
        price:22.00,
    },
    {
        id: 30,
        category: "Cabelos",
        imageUrl:"https://i.ibb.co/bB3bt2w/55fb84525cf4b9cc6dd36bbcad25b944.jpg",
        title:"Refil Shampoo Suave Mamãe e Bebê - 200ml",
        qtdInStock: 1,
        price:22.00,
    },
    {
        id: 31,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/9pjTBTY/70359-6.jpg",
        title:"Polpa Desodorante Hidratante para o Corpo Ekos Tukumã - 400 ml",
        qtdInStock: 1,
        price:70.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 32,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/8s10TvF/69824-0.jpg",
        title:" Polpa Desodorante Hidratante para o Corpo Ekos Castanha - 400 ml",
        qtdInStock: 1,
        price:70.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 33,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/cK9L5yv/73212-5.jpg",
        title:"Polpa Desodorante Hidratante Para o Corpo Ekos Andiroba - 400 ml",
        qtdInStock: 1,
        price:70.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 34,
        category: "Banho/Corpo",
        imageUrl:"https://static.natura.com/cdn/ff/JOqHHHyNyQAQuVH8DdBU8XkWl46k4aQnYTNxrfdVKow/1641354323/public/products/92786_3.jpg",
        title:"Mamãe e Bebê Água de Colônia - 100 ml",
        qtdInStock: 1,
        price:70.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 35,
        category: "Banho/Corpo",
        imageUrl:"https://static.natura.com/sites/default/files/styles/medium/public/products/9101_1_3.jpg?itok=Djqi8cuO",
        title:"Sabonete Líquido Corporal Luna Clássico - 125 ml",
        qtdInStock: 1,
        price:20.00,
    },
    {
        id: 36,
        category: "Perfumaria",
        imageUrl:"https://i.ibb.co/X4YgpBZ/D-NQ-NP-687907-MLB44836131164-022021-O.jpg",
        title:"Desodorante Colônia Ekos Copaíba - 100ml",
        qtdInStock: 1,
        price:70.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },
    {
        id: 37,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/s2B4b1W/27d57a23c1b55856.jpg",
        title:"Creme para as mãos Avelã e Cassis Natura Tododia - 50ml",
        qtdInStock: 1,
        price:20.00,
    },
   
    {
        id: 38,
        category: "Banho/Corpo",
        imageUrl:"https://i.ibb.co/1GBx438/Creme-para-as-Maos-Renew-Clare-282.jpg",
        title:"Renew Creme para as Mãos Clareador e Textura Uniforme - 75g",
        qtdInStock: 1,
        price:47.00,
        description: "À vista, o preço pode ser negociável, entre em contato ;)"

    },

]

